<template>
  <div>
    <div class="text-h5 text-center hidden-sm-and-up" v-if="$refs.calendar">
      {{ $refs.calendar.title }}
    </div>
    <v-sheet tile height="54" class="d-flex">
      <v-btn icon @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <div
        class="text-h5 ml-2 ml-lg-10 hidden-sm-and-down"
        v-if="$refs.calendar"
      >
        {{ $refs.calendar.title }}
      </div>
      <v-spacer />
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        label="Type"
      ></v-select>
      <v-select
        v-if="!singleTeacherMode"
        class="ml-2 ml-lg-5"
        v-model="teacher"
        :items="teachers"
        dense
        outlined
        hide-details
        item-value="id"
        item-text="name"
        return-object
        label="Teacher"
        @change="timestamp = Date.now()"
      ></v-select>

      <v-spacer />
      <v-btn icon @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="value"
        :type="type"
        :events="events"
        :interval-height="intervalHeight"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        :key="timestamp"
        :first-time="minDayTime"
        :categories="teachersNames"
        :interval-width="45"
        @change="getEvents"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
      >
        <!-- <template v-if="type == 'day'" v-slot:event="{ event }">
              <v-sheet
                dark
                :title="event.name"
                :color="event.color"
                height="100%"
                tile
              >
                <div class="pa-2 text-subtitle-1">{{event.name}}</div>
                <div v-if="event.teachers && event.teachers.length > 0" class="pa-2 text-subtitle-1">{{event.teachers}}</div>
              </v-sheet>
        </template> -->
      </v-calendar>

      <v-dialog v-if="selectedEvent" v-model="selectedOpen">
        <v-sheet>
          <course-schedule
            :titleColor="selectedEvent.color"
            @canceledClass="removeEvent"
            @undoCancelation="timestamp = Date.now()"
            :scheduleId="courseScheduleId"
            :scheduleDate="selectedEvent.start"
            :key="courseScheduleId"
          />

          <div class="d-flex justify-center">
            <v-btn class="my-5" text color="secondary" @click="selectedOpen = false">
              Close
            </v-btn>
          </div>
        </v-sheet>
      </v-dialog>

      <v-dialog
        v-model="selectedOpenMore"
        :close-on-content-click="false"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar>
            <v-toolbar-title>{{
              selectedMoreDate | formatDate
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text> More events... </v-card-text>
          <v-card-actions>
            <v-btn text color="secondary" @click="selectedOpenMore = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import randomColor from "randomcolor";
const CourseSchedule = () => import("@/components/course/CourseSchedule.vue");

export default {
  props: {
    teacherId: {
      type: Number,
      required: false,
    },
    singleTeacher: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    timestamp: Date.now(),
    focus: "",
    intervalHeight: 100,
    // type: "day",
    types: ["month", "week", "day", "category"],
    // selectedEvent: {},
    courseScheduleId: null,
    selectedElement: null,
    selectedOpen: false,
    selectedOpenMore: false,
    selectedMoreDate: null,
    minDayTime: "06:00",
    value: "",
    teachers: [],
    teachersNames: [],
    // teacher: null,
    singleTeacherMode: false,
    events: [],
    googleCalendarEventDialog: false,
    colors: [],
  }),
  components: {
    CourseSchedule,
  },
  computed: {
    ...mapGetters(["currentUser", "isAppLoading", "globalCenter"]),
    ...mapGetters("courseCalendar", [
      "filterTeacher",
      "filterType",
      "filterEvent",
    ]),
    teacher: {
      get() {
        return this.filterTeacher;
      },
      set(t) {
        this.setFilterTeacher(t);
      },
    },
    type: {
      get() {
        return this.filterType;
      },
      set(t) {
        this.setFilterType(t);
      },
    },
    selectedEvent: {
      get() {
        return this.filterEvent;
      },
      set(e) {
        this.setFilterEvent(e);
      },
    },
  },
  mounted() {
    console.log("mounting calendar...");

    this.colors = randomColor({
              count: 100,
              luminosity: "dark",
              format: "rgba",
              alpha: 1,
            });

console.log(`single teacher ${this.singleTeacher}`)
    this.singleTeacherMode = this.singleTeacher;

    if (this.selectedEvent && this.selectedEvent.id) {
      this.showEvent({ event: this.selectedEvent });
    }
  },
  filters: {
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    }
  },
  watch: {
    selectedOpen(dialogOpen) {
      if (!dialogOpen) {
        this.selectedEvent = null;
      }
    },
  },
  methods: {
    ...mapActions("courseCalendar", [
      "setFilterType",
      "setFilterTeacher",
      "setFilterEvent",
    ]),
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    showMore(obj) {
      const open = () => {
        this.selectedMoreDate = obj.date;
        setTimeout(() => {
          this.selectedOpenMore = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpenMore = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },
    showEvent({ event }) {
      // console.log(event);
      this.courseScheduleId = event.id;
      this.selectedEvent = event;
      this.selectedOpen = true;
    },
    getEvents({ start, end }) {
      console.log("get events");
      const min = moment(start.date);
      const max = moment(end.date);

      let selectedTeacherId = null;
      if (this.teacher && this.teacher.id) {
        selectedTeacherId = this.teacher.id;
      }

      const params = {
        start_date: min.format("YYYY-MM-DD"),
        end_date: max.format("YYYY-MM-DD"),
        teacher_id:
          this.singleTeacher && this.teacherId
            ? this.teacherId
            : selectedTeacherId,
      };

      this.$axios
        .get("/course-schedule/calendar-events", { params })
        .then((resp) => {
          const events = resp.data.data;

          //load teachers
          if (!this.singleTeacherMode) {
           this.loadTeachers(min, max)
            .then((teachers) => {
              const paddedTeachers = teachers.map((t) => {
                t.name = `${t.firstName} ${t.lastName}`;
                return t;
              });
              const allTeacher = { id: null, name: "All Teachers" };
              this.teachers = [allTeacher, ...paddedTeachers];

              this.teachersNames = paddedTeachers.map(t => t.name);

              this.prepEvents(events);
            });
          }
          else{
            this.prepEvents(events);
          }

        });
    },
    prepEvents(events){
        let courses = new Set();
        events.forEach((e) => {
          courses.add(e.name);
        });
        courses = [...courses];

        //format to Calendar Event objects
        this.events = events.map((e) => {
          const teacherIndex = this.teachers.findIndex((t) => e.teachers && e.teachers.length > 0 && t.id == e.teachers[0].id);
          const teacher = this.teachers[teacherIndex];
          const colorIndex = teacherIndex % this.colors.length;
          const color = teacher && teacher.color ? teacher.color:this.colors[colorIndex > -1 ? colorIndex:0];
          
          let eventName = e.name;
          if (this.globalCenter && !this.globalCenter.id) {
            eventName = `${eventName} (${e.data.courseName})`;
          }
          return {
            id: e.id,
            name: eventName,
            start: moment(e.start).format("YYYY-MM-DD HH:mm"),
            end: moment(e.end).format("YYYY-MM-DD HH:mm"),
            color: color,
            category: teacher ? teacher.name:''
          };
        });

        //find min hours
        if (this.events && this.events.length > 0) {
          let times = this.events.map(e => moment(e.start).format('HHmm'))
          this.minDayTime = times.reduce((t1, t2) => t1<t2 ? t1:t2);
        }
    },
    async loadTeachers(minDate, maxDate) {
      const params = {
        startDate: minDate.format("YYYY-MM-DD"),
        endDate: maxDate.format("YYYY-MM-DD"),
      };
      return await this.$axios
        .get("/teacher/allocated-teachers-by-date", { params })
        .then((resp) => {
          console.log("found teachers...");
          const teachers = resp.data.data;
          teachers.sort((t1, t2) => (t1.firstName > t2.firstName ? 1 : -1));
          return teachers;
        });
    },
    minutesOfDay(m){
      console.log(m)
      return m.minutes() + m.hours() * 60;
    },
    getEventColor(event) {
      return event.color;
    },
    removeEvent({ schedule, scheduleDate }) {
      this.events.splice(
        this.events.findIndex(
          (e) => e.id == schedule.id && e.start == scheduleDate
        ),
        1
      );
      this.selectedOpen = false;
      this.selectedEvent = null;
    },
    updatedEvent(newCourseSchedule) {
      this.selectedSchedule = newCourseSchedule;
      this.googleCalendarEventDialog = false;
    },
  },
};
</script>